import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import "../styles/styles.css";
import TripList from "./TripList";
import BookingDetailsPopup from "./BookingDetailsPopup";
import { webServiceCall } from "../../../services/pantherService";

export default function TripContent({
  onSelectTrip,
  onOpenDetails = () => {},
}) {
  // URl Params & Local Storage
  const isEnabled = (value) => value === true || value === 1 || value === "1";

  const { guid } = useParams();
  const paxData = localStorage.getItem("paxData");
  const parsedPax = paxData ? JSON.parse(paxData) : null;
  const homeAddress = parsedPax?.[0]?.Address || "Home";
  const homeLat = parsedPax?.[0]?.Lat || null;
  const homeLon = parsedPax?.[0]?.Lon || null;

  // Dates
  const today = new Date();
  const formatDate = (date) => date.toISOString().split("T")[0];
  const minDate = new Date(today);
  minDate.setFullYear(today.getFullYear() - 1);
  const maxDate = new Date(today);
  maxDate.setFullYear(today.getFullYear() + 1);
  const defaultEndDate = new Date(today);
  defaultEndDate.setDate(defaultEndDate.getDate() + 7);

  // All the states!
  const [startDate, setStartDate] = useState(formatDate(today));
  const [endDate, setEndDate] = useState(formatDate(defaultEndDate));

  const [trips, setTrips] = useState([]);
  const [timetableTrips, setTimetableTrips] = useState([]);
  const [selectedTripId, setSelectedTripId] = useState(null);
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [cancelPopupTrip, setCancelPopupTrip] = useState(null);
  const [cancelSuccessPopup, setCancelSuccessPopup] = useState(false);
  const [cancellationIsRequest, setCancellationIsRequest] = useState(false);
  const [bookPopupTrip, setBookPopupTrip] = useState(null);
  const [loading, setLoading] = useState(false);
  const [clientData, setClientData] = useState([]);
  const [clientTelNumber, setClientTelNumber] = useState([]);
  const [bookingDetailsTrips, setBookingDetailsTrips] = useState([]);
  const [selectedCancelLegIds, setSelectedCancelLegIds] = useState([]);
  const [requestTrips, setRequestTrips] = useState([
    {
      datetime: "",
      from: { type: "", name: "", lat: null, lng: null },
      to: { type: "", name: "", lat: null, lng: null },
    },
  ]);
  const [requestTimetableTrips, setRequestTimetableTrips] = useState([]);
  const [locationResults, setLocationResults] = useState([]);
  const [activeLocationField, setActiveLocationField] = useState(null);
  const [cancelReasonPopup, setCancelReasonPopup] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [phoneCancelPopup, setPhoneCancelPopup] = useState(false);
  const [undoCancelTrip, setUndoCancelTrip] = useState(null);
  const [cancellationCodes, setCancellationCodes] = useState([]);
  const [cancelResultType, setCancelResultType] = useState(null);
  const [cancelling, setCancelling] = useState(false);
  const [bookingStep, setBookingStep] = useState(0);
  const [selectedDate, setSelectedDate] = useState("");
  const [confirmPayload, setConfirmPayload] = useState([]);
  const [notes, setNotes] = useState("");

  const updated = [...requestTrips];
  const [destinationOptions, setDestinationOptions] = useState([]);
  const [aids, setAids] = useState([]);
  const [paxTypes, setPaxTypes] = useState([]);
  const [confirmButtonLoading, setConfirmButtonLoading] = useState(false);
  const [bookingResult, setBookingResult] = useState(null);
  const [tripRequestType, setTripRequestType] = useState(null);
  const [loadingTimetables, setLoadingTimetables] = useState(false);
  const [selectedTimetableTrip, setSelectedTimetableTrip] = useState(null);
  const [loadingTripConfig, setLoadingTripConfig] = useState(false);

  const timetableName = clientData?.NewBookingTimetableText || "Timetable";
  const bookingName = clientData?.NewBookingIndividualText || "Booking";
  const timetableFull = clientData?.ActionTimetableFull || 0;
  const departAtText = clientData?.NewBookingDepartAtText || "Depart At";
  const arriveByText = clientData?.NewBookingArriveByText || "Arrive By";

  const paxHasTimetableService =
    Number(parsedPax?.[0]?.HasTimeTableService) === 1;
  const paxHasBookingService = Number(parsedPax?.[0]?.HasOtherService) === 1;
  const clientAllowsTimetables = Number(clientData?.NewBookingTimetable) === 1;
  const clientAllowsBookings = Number(clientData?.NewBookingIndividual) === 1;
  const canRequestTimetable = paxHasTimetableService && clientAllowsTimetables;
  const canRequestBooking = paxHasBookingService && clientAllowsBookings;
  const canRequestAnyTrip = canRequestTimetable || canRequestBooking;

  const minDARDate = today.toISOString().split("T")[0];

  const maxDARDate = new Date(today);
  maxDARDate.setDate(
    maxDARDate.getDate() + Number(clientData?.DARMaxDaysInAdvance || 0),
  );

  const formatTime = (date) => {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  const getDefaultDARTime = (date) => {
    const today = new Date();
    const todayString =
      `${today.getFullYear()}-` +
      `${String(today.getMonth() + 1).padStart(2, "0")}-` +
      `${String(today.getDate()).padStart(2, "0")}`;

    if (date === todayString) {
      const minHours = Number(clientData?.DARMinHoursInAdvance || 0);

      const minimumTime = new Date();
      minimumTime.setHours(minimumTime.getHours() + minHours);

      return formatTime(minimumTime);
    }

    return "09:00";
  };

  // Refs
  const menuRefs = useRef({});
  const firstFromInputRef = useRef(null);
  const searchTimeoutRef = useRef(null);

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";

    const date = new Date(dateStr);

    const day = date.toLocaleDateString("en-GB", { weekday: "short" });
    const month = date.toLocaleDateString("en-GB", { month: "short" });
    const dayNum = date.getDate();

    const getSuffix = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day} ${dayNum}${getSuffix(dayNum)} ${month}`;
  };

  const confirmationText =
    tripRequestType === "timetable"
      ? clientData?.TTConfirmationText
      : clientData?.DARConfirmationText;

  const formatDateTimeDisplay = (dateTimeStr) => {
    const date = new Date(dateTimeStr);

    const datePart = formatDisplayDate(dateTimeStr);
    const timePart = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${datePart} at ${timePart}`;
  };

  const getTripsForDate = (date) => {
    if (!date) return [];

    const selectedDate = new Date(date);

    return trips.filter((trip) => {
      if (!trip.date) return false;

      const [day, month, year] = trip.date.split("/").map(Number);

      return (
        day === selectedDate.getDate() &&
        month === selectedDate.getMonth() + 1 &&
        year === selectedDate.getFullYear()
      );
    });
  };

  const resetBookingFlow = () => {
    setBookPopupTrip(false);
    setBookingStep(0);
    setTripRequestType(null);

    setSelectedDate("");
    setRequestTrips([]);
    setRequestTimetableTrips([]);

    setTimetableTrips([]);
    setSelectedTimetableTrip(null);

    setConfirmPayload([]);
    setNotes("");

    setLocationResults([]);
    setActiveLocationField(null);

    setBookingResult(null);
    setConfirmButtonLoading(false);
    setLoadingTimetables(false);
    setLoadingTripConfig(false);
  };
  const openNewTripPopup = async () => {
    setTripRequestType(null);
    setSelectedDate("");
    setRequestTrips([]);
    setRequestTimetableTrips([]);
    setTimetableTrips([]);
    setSelectedTimetableTrip(null);
    setConfirmPayload([]);
    setNotes("");
    setBookingResult(null);
    setConfirmButtonLoading(false);
    setLoadingTimetables(false);
    setLoadingTripConfig(false);

    setBookPopupTrip(true);

    if (canRequestBooking && !canRequestTimetable) {
      setTripRequestType("booking");
      setBookingStep(-10);

      const loaded = await loadTripConfig();

      if (loaded) {
        setBookingStep(1);
      } else {
        setBookingResult("error");
        setBookingStep(4);
      }

      return;
    }
    if (!canRequestBooking && canRequestTimetable) {
      setTripRequestType("timetable");
      setBookingStep(-10);

      setRequestTimetableTrips([
        {
          aid: "",
        },
      ]);

      const loaded = await loadTripConfig();

      if (loaded) {
        setBookingStep(-1);
      } else {
        setBookingResult("error");
        setBookingStep(4);
      }

      return;
    }
    setBookingStep(0);
  };

  const buildTripConfig = (data) => {
    const destinations = [];
    const aids = [];
    const paxTypes = [];

    data.forEach((item) => {
      if (item.Type === "Destination" || item.Type === "Home") {
        destinations.push({
          name: item.Destination,
          lat: item.Lat,
          lng: item.Lon,
        });
      }

      if (item.Type === "Aid") {
        aids.push({
          code: item.AidCode,
          description: item.AidDescription,
        });
      }

      if (item.Type.startsWith("PaxType")) {
        paxTypes.push({
          label: item.PaxType,
          max: item.PaxMax,
          value: item.Pax,
          key: item.Type,
        });
      }
    });

    const sortedDestinations = [
      ...destinations.filter((d) => d.name === "Home"),
      ...destinations.filter((d) => d.name !== "Home"),
    ];

    sortedDestinations.push({ name: "Other..." });

    return {
      destinations: sortedDestinations,
      aids,
      paxTypes,
    };
  };

  const loadTripConfig = async () => {
    const paxId = parsedPax?.[0]?.PaxId || "";

    if (!paxId) {
      console.warn("No passenger selected.");
      return false;
    }

    setLoadingTripConfig(true);

    try {
      const data = await webServiceCall("PaxNewTripInfo", {
        GUId: guid,
        paxId,
      });

      const {
        destinations,
        aids: loadedAids,
        paxTypes: loadedPaxTypes,
      } = buildTripConfig(data || []);

      setDestinationOptions(destinations);
      setAids(loadedAids);
      setPaxTypes(loadedPaxTypes);

      const defaultAid = getDefaultAid(loadedAids);

      setRequestTimetableTrips((currentTrips) =>
        currentTrips.map((trip) => ({
          ...trip,
          aid: defaultAid,
        })),
      );

      setRequestTrips((currentTrips) =>
        currentTrips.map((trip) => ({
          ...trip,
          aid: defaultAid,
        })),
      );

      return true;
    } catch (err) {
      console.error("Failed to load trip config:", err);

      setDestinationOptions([]);
      setAids([]);
      setPaxTypes([]);

      return false;
    } finally {
      setLoadingTripConfig(false);
    }
  };

  // client data
  useEffect(() => {
    const storedClient = localStorage.getItem("clientData");
    if (storedClient) {
      const parsed = JSON.parse(storedClient);
      setClientData(parsed);
      setClientTelNumber("tel:" + parsed.ClientBookingNumber);
    }
  }, []);

  // fetch trips
  useEffect(() => {
    fetchTrips();
  }, []);

  // focus first input when booking popup opens
  useEffect(() => {
    if (bookPopupTrip && firstFromInputRef.current) {
      firstFromInputRef.current.focus();
    }
  }, [bookPopupTrip]);

  // click outside to close menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      const openRef = menuRefs.current[menuOpenId];
      if (openRef && !openRef.contains(event.target)) {
        setMenuOpenId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpenId]);

  // click outside to close location results
  useEffect(() => {
    const handleClickOutside = () => setLocationResults([]);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // cancellation codes
  useEffect(() => {
    fetchCancellationCodes();
  }, []);

  // trip refresh every 60 secs
  useEffect(() => {
    const interval = setInterval(() => {
      fetchTrips();
    }, 60000);

    return () => clearInterval(interval);
  }, [startDate, endDate]);

  useEffect(() => {
    if (!selectedDate) return;

    const defaultTime = getDefaultDARTime(selectedDate);

    setRequestTrips((prevTrips) =>
      prevTrips.map((trip) => ({
        ...trip,
        datetime: `${selectedDate}T${defaultTime}`,
      })),
    );
  }, [selectedDate, clientData?.DARMinHoursInAdvance]);

  // webservice and functions
  const fetchTrips = async () => {
    setLoading(true);
    try {
      //remove email and use paxid
      //const email = parsedPax[0]?.Email || "";
      const paxId = parsedPax[0]?.PaxId || "";
      let parsedTrips = [];
      try {
        parsedTrips = await webServiceCall("PaxTrips", {
          GUId: guid,
          paxId: paxId,
          fromDate: startDate,
          toDate: endDate,
        });
      } catch (err) {
        console.warn("Failed to parse trips JSON:", err);
      }

      const formatted = parsedTrips.map((trip, idx) => ({
        id: idx,
        inBoxId: trip.InBoxId,
        tripId: trip.TripId,
        regular: trip.IsRegular,
        status: trip.Status,
        aid: trip.Aid,
        passengers: Number(trip.Pax_Total) || 0,
        cancellationStatus: parseInt(trip.CancellationStatus),
        from: {
          name: trip.PU_Address,
          lat: parseFloat(trip.PU_Lat),
          lng: parseFloat(trip.PU_Lon),
        },
        to: {
          name: trip.DO_Address,
          lat: parseFloat(trip.DO_Lat),
          lng: parseFloat(trip.DO_Lon),
        },
        fare: trip.AmountDue,
        amountDue: trip.AmountDue,
        date: trip.Date,
        formatteddate: trip.FormattedDate,
        time: trip.Time,
        bookingId: trip.BookingID,
        paymentMethod: trip.PaymentMethod,
        isTimetable:
          trip.IsTimetable === true ||
          trip.IsTimetable === 1 ||
          trip.IsTimetable === "1",
        description: trip.Description,
      }));
      setTrips(formatted);
    } catch (err) {
      console.error("Failed to fetch trips:", err);
    } finally {
      setLoading(false);
    }
  };

  const getDefaultAid = (availableAids) => {
    if (availableAids.length === 0) return "None";
    if (availableAids.length === 1) return availableAids[0].code;

    return "";
  };

  const fetchTimetableTrips = async ({
    aidCode,
    intPaxType1,
    intPaxType2,
    intPaxType3,
  }) => {
    const paxId = parsedPax?.[0]?.PaxId ?? "";

    setLoadingTimetables(true);
    setTimetableTrips([]);

    if (!paxId) {
      console.warn("No passenger selected.");
      setLoadingTimetables(false);
      return [];
    }

    try {
      const trips = await webServiceCall("PaxGetTimetables", {
        GUId: guid,
        PaxId: paxId,
        AidCode: aidCode === "None" ? "" : aidCode,
        intPaxType1,
        intPaxType2,
        intPaxType3,
      });

      const formattedTrips = (trips || []).map((trip) => ({
        ...trip,
        Date: trip.Date ? new Date(trip.Date) : null,
        TimeOut: trip.TimeOut ? new Date(trip.TimeOut) : null,
        TimeReturn: trip.TimeReturn ? new Date(trip.TimeReturn) : null,
      }));

      setTimetableTrips(formattedTrips);

      return formattedTrips;
    } catch (err) {
      console.error("Failed to fetch timetable trips:", err);
      setTimetableTrips([]);

      return [];
    } finally {
      setLoadingTimetables(false);
    }
  };

  const getExistingTripsForDate = (dateValue) => {
    if (!dateValue) return [];

    const requestedDate = new Date(dateValue);

    if (Number.isNaN(requestedDate.getTime())) {
      return [];
    }

    return trips.filter((trip) => {
      if (!trip.date) return false;

      const [day, month, year] = trip.date.split("/").map(Number);

      const isSameDate =
        day === requestedDate.getDate() &&
        month === requestedDate.getMonth() + 1 &&
        year === requestedDate.getFullYear();

      const isCancelled = trip.status?.startsWith("Cancelled - ");
      const isRefused = trip.status?.startsWith("Refused - ");

      return isSameDate && !isCancelled && !isRefused;
    });
  };

  const fetchCancellationCodes = async () => {
    try {
      let parsedCodes = [];
      try {
        parsedCodes = await webServiceCall("GetCancellationCodes", {
          GUId: guid,
        });
      } catch (err) {
        console.warn("Failed to parse cancellation codes JSON:", err);
      }

      setCancellationCodes(parsedCodes);
      setCancelReason(parsedCodes.length === 1 ? parsedCodes[0].Code : "");
    } catch (err) {
      console.error("Failed to fetch cancellation codes:", err);
    }
  };

  const getTripError = (trip, index) => {
    if (!trip.datetime) return null;

    const departure = new Date(trip.datetime);

    if (trip.isReturn && trip.returnTime) {
      const returnDate = new Date(`${selectedDate}T${trip.returnTime}`);

      if (returnDate <= departure) {
        return "Return time must be after departure time";
      }
    }

    return null;
  };

  const hasInvalidTrips = requestTrips.some((trip, index) =>
    getTripError(trip, index),
  );

  const searchLocation = async (query) => {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${query}`,
    );
    return await res.json();
  };

  // requested trips helpers
  const updateRequestTrip = (index, field, value) => {
    const updated = [...requestTrips];
    updated[index][field] = value;
    setRequestTrips(updated);
  };

  const isTripValid = (trip) => {
    if (!trip.datetime) return false;
    if (!trip.from?.name) return false;
    if (!trip.to?.name) return false;

    const dateTime = new Date(trip.datetime);
    if (isNaN(dateTime.getTime())) return false;

    const now = new Date();
    if (dateTime < now) return false;

    if (trip.isReturn && trip.returnTime) {
      const returnDateTime = new Date(`${selectedDate}T${trip.returnTime}`);
      if (returnDateTime < now) return false;
    }

    return true;
  };

  const canBook = (() => {
    const validTrips = requestTrips.every(
      (trip) =>
        trip.from?.name && trip.to?.name && trip.datetime && trip.aid !== "",
    );

    const hasPassengers = paxTypes.some((p) => Number(p.value) > 0);

    return validTrips && hasPassengers;
  })();

  const canBookTimetable = (() => {
    const hasPassengers = paxTypes.some((p) => Number(p.value) > 0);

    const hasSelectedAid = requestTimetableTrips.every(
      (trip) => trip.aid !== "",
    );

    return hasPassengers && hasSelectedAid;
  })();

  const updateRequestLocation = (index, field, value) => {
    const updated = [...requestTrips];
    updated[index][field] = value;
    setRequestTrips(updated);
  };

  const addRequestTrip = () => {
    setRequestTrips([
      ...requestTrips,
      {
        datetime: "",
        from: { type: "", name: "", lat: null, lng: null },
        to: { type: "", name: "", lat: null, lng: null },
        aid: getDefaultAid(aids),
      },
    ]);
  };

  const resetTripBuilder = () => {
    setRequestTrips([
      {
        datetime: "",
        returnTime: "",
        isReturn: false,
        from: { type: "", name: "", lat: null, lng: null },
        to: { type: "", name: "", lat: null, lng: null },
        aid: getDefaultAid(aids),
      },
    ]);
    setLocationResults([]);
    setActiveLocationField(null);
  };

  const handleLocationSearch = (value, index, field) => {
    setActiveLocationField({ index, field });
    updateRequestLocation(index, field, {
      ...requestTrips[index][field],
      name: value,
    });

    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length < 3) return setLocationResults([]);

    searchTimeoutRef.current = setTimeout(async () => {
      const results = await searchLocation(value);
      setLocationResults(results);
    }, 400);
  };

  // Trip and menu handlers
  const handleSelectTrip = (trip) => {
    setSelectedTripId(trip.id);
    onSelectTrip(trip);
  };

  const handleMenuToggle = (tripId) => {
    setMenuOpenId((prev) => (prev === tripId ? null : tripId));
  };

  const submitCancellation = async (reasonId) => {
    try {
      const selectedTrips = trips.filter((trip) =>
        selectedCancelLegIds.includes(trip.id),
      );

      if (selectedTrips.length === 0) return;

      const isCancellationRequest = selectedTrips[0].cancellationStatus === 2;

      const method = isCancellationRequest
        ? "RequestCancellation"
        : "FullCancellation";

      setCancelPopupTrip(null);
      setCancelReasonPopup(false);

      setCancellationIsRequest(isCancellationRequest);
      setCancelling(true);

      for (const trip of selectedTrips) {
        await webServiceCall(method, {
          GUId: guid,
          inBoxId: trip.inBoxId,
          tripId: trip.tripId,
          reasonId,
        });
      }

      setCancelResultType(isCancellationRequest ? "request" : "cancelled");

      setCancelReason("");
      setSelectedCancelLegIds([]);

      setCancelling(false);
      setCancelSuccessPopup(true);

      fetchTrips();
    } catch (err) {
      console.error("Cancellation failed:", err);
      setCancelling(false);
    }
  };

  return (
    <aside className="right">
      <div className="card">
        <div className="top-section">
          <div className="title-actions">
            <h2 className="h1">Trips</h2>
            {canRequestAnyTrip && (
              <button className="button" onClick={openNewTripPopup}>
                {canRequestTimetable && !canRequestBooking
                  ? `Request ${timetableName}`
                  : canRequestBooking && !canRequestTimetable
                    ? `Request ${bookingName}`
                    : "Request Trip"}
              </button>
            )}
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "10px",
            }}
          >
            <input
              type="date"
              className="date-picker"
              value={startDate}
              min={formatDate(minDate)}
              max={formatDate(maxDate)}
              onChange={(e) => setStartDate(e.target.value)}
              style={{ flex: "1 1 120px" }}
            />

            <input
              type="date"
              className="date-picker"
              value={endDate}
              min={formatDate(minDate)}
              max={formatDate(maxDate)}
              onChange={(e) => setEndDate(e.target.value)}
              style={{ flex: "1 1 120px" }}
            />
          </div>

          <button
            className="button full-width"
            onClick={fetchTrips}
            disabled={loading}
          >
            {loading ? "Loading..." : "Filter/Refresh Trips ⟳"}
          </button>
        </div>

        <TripList
          trips={trips}
          selectedTripId={selectedTripId}
          menuOpenId={menuOpenId}
          menuRefs={menuRefs}
          onSelectTrip={handleSelectTrip}
          onMenuToggle={handleMenuToggle}
          onOpenBookingDetails={setBookingDetailsTrips}
          onPhoneCancel={() => setPhoneCancelPopup(true)}
          onPrepareCancel={(trip) => {
            setSelectedCancelLegIds([]);
            fetchCancellationCodes();
            setCancelPopupTrip(trip);
          }}
          onUndoCancel={setUndoCancelTrip}
        />
      </div>
      {/* Phone Cancel Popup */}
      {phoneCancelPopup && (
        <div
          className="popup-wrapper"
          onClick={() => setPhoneCancelPopup(false)}
        >
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <span>Cancel Trip</span>
              <button
                className="popup-close"
                onClick={() => setPhoneCancelPopup(false)}
              >
                ×
              </button>
            </div>

            <div
              className="popup-body"
              dangerouslySetInnerHTML={{
                __html: clientData.ClientCancellationInfo,
              }}
            />
          </div>
        </div>
      )}

      {undoCancelTrip && (
        <div className="popup-wrapper" onClick={() => setUndoCancelTrip(null)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <span>Undo Cancel Request</span>
              <button
                className="popup-close"
                onClick={() => setUndoCancelTrip(null)}
              >
                ×
              </button>
            </div>

            <div className="popup-body">
              <p>Are you sure you want to undo your cancel request?</p>

              <button
                className="button full-width"
                onClick={async () => {
                  await webServiceCall("UndoCancellationRequest", {
                    GUId: guid,
                    tripId: undoCancelTrip.tripId,
                  });
                  setUndoCancelTrip(null);
                  fetchTrips();
                }}
              >
                Yes, Undo Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {cancelPopupTrip && (
        <div className="popup-wrapper" onClick={() => setCancelPopupTrip(null)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <span>Cancel Trip</span>
              <button
                className="popup-close"
                onClick={() => setCancelPopupTrip(null)}
              >
                ×
              </button>
            </div>

            <div className="popup-body">
              <p>Select which you would like to cancel:</p>

              <div className="cancel-leg-list">
                {trips
                  .filter((t) => t.bookingId === cancelPopupTrip.bookingId)
                  .map((leg) => {
                    const isCancelled = leg.status.startsWith("Cancelled - ");
                    const isRefused = leg.status.startsWith("Refused - ");
                    const [day, month, year] = leg.date.split("/").map(Number);
                    const [hours, minutes] = leg.time.split(":").map(Number);
                    const legDateTime = new Date(
                      year,
                      month - 1,
                      day,
                      hours,
                      minutes,
                    );
                    const now = new Date();
                    const isPastTrip = legDateTime < now;

                    const isPendingCancel = leg.cancellationStatus === 4;
                    const isDisabled =
                      isCancelled || isRefused || isPastTrip || isPendingCancel;

                    const isSelected = selectedCancelLegIds.includes(leg.id);
                    return (
                      <div
                        key={leg.id}
                        className={`cancel-leg-item ${isSelected ? "active" : ""} ${
                          isDisabled ? "disabled" : ""
                        }`}
                        onClick={() => {
                          if (isDisabled) return;

                          setSelectedCancelLegIds((previousSelectedIds) => {
                            if (!leg.isTimetable) {
                              return previousSelectedIds.includes(leg.id)
                                ? previousSelectedIds.filter(
                                    (id) => id !== leg.id,
                                  )
                                : [...previousSelectedIds, leg.id];
                            }

                            const timetableLegIds = trips
                              .filter(
                                (trip) =>
                                  trip.bookingId === leg.bookingId &&
                                  trip.isTimetable &&
                                  !trip.status.startsWith("Cancelled - ") &&
                                  !trip.status.startsWith("Refused - ") &&
                                  trip.cancellationStatus !== 4,
                              )
                              .map((trip) => trip.id);

                            const allTimetableLegsSelected =
                              timetableLegIds.every((id) =>
                                previousSelectedIds.includes(id),
                              );

                            if (allTimetableLegsSelected) {
                              return previousSelectedIds.filter(
                                (id) => !timetableLegIds.includes(id),
                              );
                            }

                            return [
                              ...new Set([
                                ...previousSelectedIds,
                                ...timetableLegIds,
                              ]),
                            ];
                          });
                        }}
                      >
                        <strong>
                          {leg.formatteddate} at {leg.time}
                        </strong>
                        <div>
                          {leg.from.name} → {leg.to.name}
                        </div>

                        {isDisabled && (
                          <div style={{ fontSize: "12px", color: "#888" }}>
                            {isCancelled
                              ? "Already Cancelled"
                              : isRefused
                                ? "Refused"
                                : isPendingCancel
                                  ? "Pending Cancel"
                                  : "Past Trip"}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
              <p>Anything in red will be cancelled!</p>
              <button
                className="button full-width"
                disabled={selectedCancelLegIds.length === 0}
                onClick={async () => {
                  setCancelPopupTrip(null);

                  if (cancellationCodes.length === 1) {
                    const singleCancellationCode = cancellationCodes[0].Code;

                    await submitCancellation(singleCancellationCode);
                    return;
                  }

                  setCancelReason("");
                  setCancelReasonPopup(true);
                }}
              >
                {selectedCancelLegIds.length ===
                trips.filter(
                  (trip) => trip.bookingId === cancelPopupTrip.bookingId,
                ).length
                  ? "Request Cancel For Whole Booking"
                  : "Request Cancel For Selected"}
              </button>
            </div>
          </div>
        </div>
      )}

      {cancelReasonPopup && (
        <div
          className="popup-wrapper"
          onClick={() => setCancelReasonPopup(false)}
        >
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <span>Cancellation Reason</span>
              <button
                className="popup-close"
                onClick={() => setCancelReasonPopup(false)}
              >
                ×
              </button>
            </div>

            <div className="popup-body">
              <p>Please select a reason for cancelling:</p>

              <select
                className="date-picker"
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
              >
                <option value="">Select reason</option>
                {cancellationCodes.map((code) => (
                  <option key={code.Code} value={code.Code}>
                    {code.Description}
                  </option>
                ))}
              </select>

              <button
                className="button full-width"
                style={{ marginTop: "10px" }}
                disabled={!cancelReason}
                onClick={() => submitCancellation(cancelReason)}
              >
                Confirm Cancellation
              </button>
            </div>
          </div>
        </div>
      )}
      {cancelling && (
        <div className="popup-wrapper">
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <span>Cancelling Trip</span>
            </div>

            <div
              className="popup-body"
              style={{
                textAlign: "center",
                padding: "40px 20px",
              }}
            >
              <i
                className="fa-solid fa-spinner fa-spin"
                style={{
                  display: "block",
                  fontSize: "2rem",
                  marginBottom: "15px",
                }}
              />

              <h3>
                {cancellationIsRequest
                  ? "Submitting cancellation request..."
                  : "Cancelling trip..."}
              </h3>

              <p>Please wait while we process your cancellation.</p>
            </div>
          </div>
        </div>
      )}
      {cancelSuccessPopup && (
        <div
          className="popup-wrapper"
          onClick={() => setCancelSuccessPopup(false)}
        >
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <span>Trip Cancelled</span>

              <button
                className="popup-close"
                onClick={() => setCancelSuccessPopup(false)}
              >
                ×
              </button>
            </div>

            <div
              className="popup-body"
              style={{
                textAlign: "center",
                padding: "30px",
              }}
            >
              <h2 style={{ color: "green" }}>Complete</h2>

              <div
                dangerouslySetInnerHTML={{
                  __html:
                    clientData.PaxCancellationSuccesfulText ||
                    "Cancel successful!",
                }}
              />

              <button
                className="button"
                style={{ marginTop: "20px" }}
                onClick={() => setCancelSuccessPopup(false)}
              >
                Continue...
              </button>
            </div>
          </div>
        </div>
      )}

      {bookPopupTrip && (
        <div className="popup-wrapper">
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <span>
                {bookingStep === -4 || bookingStep === 2.5
                  ? "Existing Trips Found"
                  : bookingStep === -3
                    ? `Confirm New ${timetableName} Trip`
                    : bookingStep === 3
                      ? `Confirm New ${bookingName}`
                      : bookingStep === 2
                        ? `Request New ${bookingName}`
                        : bookingStep < 0 && bookingStep !== -10
                          ? `Request New ${timetableName} Trip`
                          : "Request New Trip"}

                {selectedDate && ` For ${formatDisplayDate(selectedDate)}`}
              </span>
              <button
                className="popup-close"
                onClick={() => {
                  resetBookingFlow();
                }}
              >
                ×
              </button>
            </div>

            {bookingStep === 0 && (
              <div className="popup-body">
                <p>Please select what you would like to do:</p>

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    marginTop: "15px",
                  }}
                >
                  {canRequestTimetable && (
                    <button
                      className="button"
                      style={{ flex: 1 }}
                      onClick={async () => {
                        setTripRequestType("timetable");
                        setBookingStep(-10);

                        setRequestTimetableTrips([
                          {
                            aid: "",
                          },
                        ]);

                        setTimetableTrips([]);
                        setSelectedTimetableTrip(null);
                        setConfirmPayload([]);

                        const loaded = await loadTripConfig();

                        if (loaded) {
                          setBookingStep(-1);
                        } else {
                          setBookingResult("error");
                          setBookingStep(4);
                        }
                      }}
                    >
                      {timetableName}
                    </button>
                  )}

                  {canRequestBooking && (
                    <button
                      className="button"
                      style={{ flex: 1 }}
                      onClick={async () => {
                        setTripRequestType("booking");
                        setBookingStep(-10);

                        const loaded = await loadTripConfig();

                        if (loaded) {
                          setBookingStep(1);
                        } else {
                          setBookingResult("error");
                          setBookingStep(4);
                        }
                      }}
                    >
                      {bookingName}
                    </button>
                  )}
                </div>
              </div>
            )}

            <div className="popup-body">
              {bookingStep === -1 && (
                <>
                  {requestTimetableTrips.map((trip, index) => {
                    return (
                      <div>
                        <div style={{ marginBottom: "10px" }}>
                          <label>Aid:</label>
                          <select
                            value={trip.aid ?? ""}
                            onChange={(e) => {
                              const updated = [...requestTimetableTrips];
                              updated[index] = {
                                ...updated[index],
                                aid: e.target.value,
                              };
                              setRequestTimetableTrips(updated);
                            }}
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              marginBottom: "8px",
                              borderRadius: "8px",
                              border: "1px solid #d0d0d0",
                              backgroundColor: "#fff",
                              fontSize: "14px",
                              outline: "none",
                            }}
                            onFocus={(e) => {
                              e.target.style.border = "1px solid #000";
                            }}
                            onBlur={(e) => {
                              e.target.style.border = "1px solid #d0d0d0";
                            }}
                          >
                            {aids.length > 1 && (
                              <option value="" disabled>
                                Select an aid...
                              </option>
                            )}

                            <option value="None">None</option>

                            {aids.map((aid) => (
                              <option key={aid.code} value={aid.code}>
                                {aid.description}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div
                          style={{
                            marginTop: "12px",
                            paddingTop: "8px",
                            borderTop: "1px solid #eee",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        ></div>

                        <div style={{ marginBottom: "10px" }}>
                          <label>Passengers:</label>
                          {paxTypes.map((pax, i) => (
                            <div key={pax.key} style={{ marginBottom: "10px" }}>
                              <label>{pax.label}</label>

                              <input
                                type="number"
                                min="0"
                                max={pax.max}
                                value={pax.value}
                                onChange={(e) => {
                                  const updated = [...paxTypes];
                                  updated[i].value = Math.min(
                                    pax.max,
                                    Math.max(0, Number(e.target.value)),
                                  );
                                  setPaxTypes(updated);
                                }}
                              />
                            </div>
                          ))}
                        </div>

                        <div
                          style={{
                            marginTop: "12px",
                            paddingTop: "8px",
                            borderTop: "1px solid #eee",
                            position: "relative",
                          }}
                        ></div>
                      </div>
                    );
                  })}
                  <button
                    className="button full-width"
                    style={{
                      marginTop: "10px",
                      opacity: canBookTimetable ? 1 : 0.4,
                      cursor: canBookTimetable ? "pointer" : "not-allowed",
                    }}
                    disabled={!canBookTimetable}
                    onClick={async () => {
                      if (!canBookTimetable) return;

                      const firstTimetableRequest = requestTimetableTrips[0];
                      const aidCode = firstTimetableRequest?.aid;

                      const intPaxType1 =
                        Number(
                          paxTypes.find((p) => p.key === "PaxType1")?.value,
                        ) || 0;

                      const intPaxType2 =
                        Number(
                          paxTypes.find((p) => p.key === "PaxType2")?.value,
                        ) || 0;

                      const intPaxType3 =
                        Number(
                          paxTypes.find((p) => p.key === "PaxType3")?.value,
                        ) || 0;

                      const totalPassengers =
                        intPaxType1 + intPaxType2 + intPaxType3;

                      const aidObj = aids.find((a) => a.code === aidCode);

                      setConfirmPayload([
                        {
                          aidCode: aidCode === "None" ? null : aidCode,
                          aid: aidObj?.description || "None",
                          passengers: totalPassengers,
                          paxType1: intPaxType1,
                          paxType2: intPaxType2,
                          paxType3: intPaxType3,
                        },
                      ]);

                      setSelectedTimetableTrip(null);
                      setBookingStep(-2);

                      await fetchTimetableTrips({
                        aidCode,
                        intPaxType1,
                        intPaxType2,
                        intPaxType3,
                      });
                    }}
                  >
                    View Available Trips
                  </button>
                </>
              )}
              {bookingStep === -2 && (
                <>
                  {loadingTimetables ? (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "40px 20px",
                      }}
                    >
                      <i
                        className="fa-solid fa-spinner fa-spin"
                        style={{
                          display: "block",
                          fontSize: "2rem",
                          marginBottom: "15px",
                        }}
                      />

                      <h3>Finding available {timetableName}...</h3>

                      <p>Please wait while we check the available journeys.</p>
                    </div>
                  ) : timetableTrips.length === 0 ? (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "40px 20px",
                      }}
                    >
                      <i
                        className="fa-solid fa-circle-info"
                        style={{
                          display: "block",
                          fontSize: "2rem",
                          marginBottom: "15px",
                          color: "#666",
                        }}
                      />

                      <h3>No {timetableName} available</h3>

                      <p>
                        There are currently no available journeys matching the
                        selected aid and passenger requirements.
                      </p>

                      <button
                        className="button"
                        style={{ marginTop: "15px" }}
                        onClick={() => {
                          setTimetableTrips([]);
                          setSelectedTimetableTrip(null);
                          setBookingStep(-1);
                        }}
                      >
                        Change Search
                      </button>
                    </div>
                  ) : (
                    <>
                      {timetableTrips
                        .filter((trip) => {
                          const isFull = Number(trip.Full) === 1;

                          if (isFull && Number(timetableFull) === 0) {
                            return false;
                          }

                          return true;
                        })
                        .map((trip, index) => {
                          const totalPassengers = paxTypes.reduce(
                            (sum, pax) => sum + (Number(pax.value) || 0),
                            0,
                          );

                          const selectedAid =
                            confirmPayload?.[0]?.aid || "None";

                          const isPending = Number(trip.IsPending) === 1;
                          const isBooked = Number(trip.Booked) === 1;
                          const isFull = Number(trip.Full) === 1;

                          const displayedPassengers =
                            isBooked || isPending
                              ? Number(trip.PassengerCount) || 0
                              : totalPassengers;

                          const bookedAidDescription =
                            aids.find((aid) => aid.code === trip.BookedAid)
                              ?.description ||
                            trip.BookedAid ||
                            "None";

                          const displayedAid =
                            isBooked || isPending
                              ? bookedAidDescription
                              : selectedAid;

                          const isDisabled =
                            isBooked ||
                            isPending ||
                            (isFull && Number(timetableFull) === 1);

                          let statusText = "Available";
                          let statusColour = "#FFBF00";
                          let statusTitle =
                            "This timetable is available to book.";

                          if (isBooked) {
                            statusText = "Booked";
                            statusColour = "#2e7d32";
                            statusTitle =
                              "You have already booked this timetable trip.";
                          } else if (isPending) {
                            statusText = "Pending";
                            statusColour = "#777";
                            statusTitle =
                              "Booking is already pending, cancel and book again to amend booking.";
                          } else if (isFull) {
                            statusText = "Full";
                            statusColour = "#d32f2f";
                            statusTitle = "This timetable trip is full.";
                          }

                          const outboundTime = trip.TimeOut
                            ? trip.TimeOut.toLocaleTimeString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                              })
                            : "Not available";

                          const returnTime = trip.TimeReturn
                            ? trip.TimeReturn.toLocaleTimeString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                              })
                            : "Not available";

                          const selectTrip = () => {
                            if (isDisabled) return;

                            setSelectedTimetableTrip(trip);

                            const existingTrips = getExistingTripsForDate(
                              trip.Date,
                            );

                            if (existingTrips.length > 0) {
                              setBookingStep(-4);
                            } else {
                              setBookingStep(-3);
                            }
                          };

                          return (
                            <div
                              key={`${trip.Id}-${trip.Date?.getTime?.() ?? index}`}
                              className={`booking-trip-card ${isDisabled ? "pending" : ""}`}
                              role={isDisabled ? undefined : "button"}
                              tabIndex={isDisabled ? -1 : 0}
                              aria-disabled={isDisabled}
                              onClick={selectTrip}
                              onKeyDown={(event) => {
                                if (
                                  !isDisabled &&
                                  (event.key === "Enter" || event.key === " ")
                                ) {
                                  event.preventDefault();
                                  selectTrip();
                                }
                              }}
                              style={{
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                opacity: isDisabled ? 0.7 : 1,
                              }}
                            >
                              <div className="booking-trip-header">
                                <strong>
                                  {formatDisplayDate(trip.Date)}
                                  {" — "}
                                  Out: {outboundTime}
                                  {" / "}
                                  Return: {returnTime}
                                </strong>
                              </div>

                              <div
                                className="booking-trip-icon"
                                title={statusTitle}
                                style={{
                                  backgroundColor: statusColour,
                                }}
                              >
                                <span
                                  style={{
                                    color: "white",
                                    fontSize: "0.75rem",
                                    fontWeight: "600",
                                  }}
                                >
                                  {statusText}
                                </span>
                              </div>

                              <div className="booking-trip-body">
                                <p>
                                  <strong>To:</strong>{" "}
                                  {trip.Description || "Not available"}
                                </p>

                                <p>
                                  <strong>Aid:</strong> {displayedAid}
                                </p>

                                <p>
                                  <strong>Passengers:</strong>{" "}
                                  {displayedPassengers}
                                </p>

                                <div
                                  style={{
                                    marginTop: "8px",
                                    padding: "8px 10px",
                                    borderRadius: "6px",
                                    backgroundColor: "#f5f5f5",
                                    color: "#555",
                                    fontSize: "13px",
                                    lineHeight: "1.4",
                                  }}
                                >
                                  {statusTitle}
                                </div>
                              </div>
                            </div>
                          );
                        })}

                      <button
                        className="button full-width"
                        style={{ marginTop: "15px" }}
                        onClick={() => {
                          setTimetableTrips([]);
                          setSelectedTimetableTrip(null);
                          setBookingStep(-1);
                        }}
                      >
                        Change Search
                      </button>
                    </>
                  )}
                </>
              )}
              {bookingStep === -4 && selectedTimetableTrip && (
                <>
                  <div
                    style={{
                      padding: "14px",
                      marginBottom: "15px",
                      border: "1px solid #e0a800",
                      borderRadius: "8px",
                      backgroundColor: "#fff8dd",
                    }}
                  >
                    <h3 style={{ marginTop: 0 }}>Trips already booked</h3>

                    <p>
                      You already have one or more trips booked on{" "}
                      <strong>
                        {formatDisplayDate(selectedTimetableTrip.Date)}
                      </strong>
                      .
                    </p>

                    <p>
                      Please check these trips before continuing with the new{" "}
                      {timetableName.toLowerCase()} request.
                    </p>
                  </div>

                  <div className="array-list">
                    {getExistingTripsForDate(selectedTimetableTrip.Date).map(
                      (trip) => (
                        <div
                          key={`existing-trip-${trip.id}`}
                          className="booking-trip-card"
                        >
                          <div className="booking-trip-header">
                            <strong>
                              {trip.formatteddate} at {trip.time}
                            </strong>
                          </div>

                          <div
                            className="booking-trip-icon"
                            style={{ backgroundColor: "#2e7d32" }}
                          >
                            <span
                              style={{
                                color: "white",
                                fontSize: "0.75rem",
                                fontWeight: "600",
                              }}
                            >
                              Booked
                            </span>
                          </div>

                          <div className="booking-trip-body">
                            <p>
                              <strong>From:</strong>{" "}
                              {trip.from?.name || "Not available"}
                            </p>

                            <p>
                              <strong>To:</strong>{" "}
                              {trip.to?.name || "Not available"}
                            </p>

                            <p>
                              <strong>Aid:</strong> {trip.aid || "None"}
                            </p>

                            <p>
                              <strong>Passengers:</strong> {trip.passengers}
                            </p>

                            {trip.status && (
                              <p>
                                <strong>Status:</strong> {trip.status}
                              </p>
                            )}
                          </div>
                        </div>
                      ),
                    )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginTop: "15px",
                    }}
                  >
                    <button
                      className="button"
                      style={{ flex: 1 }}
                      onClick={() => {
                        setSelectedTimetableTrip(null);
                        setBookingStep(-2);
                      }}
                    >
                      Back
                    </button>

                    <button
                      className="button"
                      style={{ flex: 1 }}
                      onClick={() => setBookingStep(-3)}
                    >
                      OK, Continue
                    </button>
                  </div>
                </>
              )}
              {bookingStep === -3 && selectedTimetableTrip && (
                <>
                  <div className="booking-trip-card">
                    <div className="booking-trip-header">
                      <strong>
                        {formatDisplayDate(selectedTimetableTrip.Date)}
                        {" — "}
                        Out:{" "}
                        {selectedTimetableTrip.TimeOut?.toLocaleTimeString(
                          "en-GB",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                          },
                        )}
                        {" / "}
                        Return:{" "}
                        {selectedTimetableTrip.TimeReturn?.toLocaleTimeString(
                          "en-GB",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                          },
                        )}
                      </strong>
                    </div>

                    <div
                      className="booking-trip-icon"
                      style={{ backgroundColor: "#FFBF00" }}
                    >
                      <i
                        className="fa-solid fa-bus"
                        style={{ color: "white" }}
                      />
                    </div>

                    <div className="booking-trip-body">
                      <p>
                        <strong>To:</strong> {selectedTimetableTrip.Description}
                      </p>

                      <p>
                        <strong>Aid:</strong> {confirmPayload[0]?.aid || "None"}
                      </p>
                      <p>
                        <strong>Passengers:</strong>{" "}
                        {paxTypes.reduce(
                          (total, pax) => total + (Number(pax.value) || 0),
                          0,
                        )}
                      </p>
                    </div>
                  </div>

                  <div
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      gap: "10px",
                    }}
                  >
                    <button
                      className="button"
                      style={{ flex: 1 }}
                      disabled={confirmButtonLoading}
                      onClick={() => {
                        setSelectedTimetableTrip(null);
                        setBookingStep(-2);
                      }}
                    >
                      Back
                    </button>

                    <button
                      className="button"
                      style={{ flex: 1 }}
                      disabled={confirmButtonLoading}
                      onClick={async () => {
                        setConfirmButtonLoading(true);

                        try {
                          const intPaxType1 =
                            Number(
                              paxTypes.find((p) => p.key === "PaxType1")?.value,
                            ) || 0;

                          const intPaxType2 =
                            Number(
                              paxTypes.find((p) => p.key === "PaxType2")?.value,
                            ) || 0;

                          const intPaxType3 =
                            Number(
                              paxTypes.find((p) => p.key === "PaxType3")?.value,
                            ) || 0;

                          const aidCode = confirmPayload[0]?.aidCode || "";
                          const tripDate =
                            selectedTimetableTrip.Date.toLocaleDateString();

                          await webServiceCall("CreateTimetableBooking", {
                            GUId: guid,
                            paxId: parsedPax?.[0]?.PaxId || "",
                            timetableId: String(selectedTimetableTrip.Id),
                            tripDate,
                            intPaxType1,
                            intPaxType2,
                            intPaxType3,
                            aidCode,
                          });

                          setBookingResult("success");
                          setBookingStep(4);
                        } catch (err) {
                          console.error("Timetable booking failed:", err);
                          setBookingResult("error");
                          setBookingStep(4);
                        } finally {
                          setConfirmButtonLoading(false);
                        }
                      }}
                    >
                      {confirmButtonLoading
                        ? "Requesting..."
                        : "Confirm Request"}
                    </button>
                  </div>
                </>
              )}

              {bookingStep === -10 && (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px 20px",
                  }}
                >
                  <i
                    className="fa-solid fa-spinner fa-spin"
                    style={{
                      display: "block",
                      fontSize: "2rem",
                      marginBottom: "15px",
                    }}
                  />

                  <h3>
                    {tripRequestType === "timetable"
                      ? `Loading ${timetableName} options...`
                      : `Loading ${bookingName} options...`}
                  </h3>

                  <p>Loading passenger types and available aids.</p>
                </div>
              )}

              {bookingStep === 1 && (
                <>
                  <p>Please select a date:</p>

                  <input
                    type="date"
                    className="date-picker"
                    value={selectedDate}
                    min={minDARDate}
                    max={maxDARDate.toISOString().split("T")[0]}
                    onChange={(e) => setSelectedDate(e.target.value)}
                  />

                  <button
                    className="button full-width"
                    disabled={!selectedDate}
                    style={{ marginTop: "10px" }}
                    onClick={() => {
                      setBookingStep(2);

                      const defaultTime = getDefaultDARTime(selectedDate);

                      setRequestTrips([
                        {
                          datetime: `${selectedDate}T${defaultTime}`,
                          from: {
                            name: homeAddress,
                            lat: homeLat,
                            lng: homeLon,
                          },
                          to: { name: "", lat: null, lng: null },
                          mode: "departing",
                          aid: getDefaultAid(aids),
                        },
                      ]);
                    }}
                  >
                    Next
                  </button>
                </>
              )}

              {bookingStep === 2 && (
                <>
                  {requestTrips.map((trip, index) => {
                    const isTimeValid = (idx, newTime) => {
                      if (idx === 0) return true;

                      const prevTrip = requestTrips[idx - 1];
                      if (!prevTrip.datetime) return true;

                      const prev = new Date(prevTrip.datetime);
                      const current = new Date(`${selectedDate}T${newTime}`);

                      return current > prev;
                    };

                    const currentTime = trip.datetime
                      ? trip.datetime.split("T")[1]
                      : "";

                    const isInvalidTime =
                      index > 0 &&
                      currentTime &&
                      !isTimeValid(index, currentTime);

                    return (
                      <div key={index} className="trip-builder-card">
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          {/* FROM */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "6px",
                              marginBottom: "10px",
                            }}
                          >
                            <label style={{ fontWeight: 600 }}>From:</label>

                            <div className="styled-select">
                              <select
                                value={
                                  trip.fromMode === "manual"
                                    ? "Other"
                                    : trip.from.name || "select"
                                }
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const updated = [...requestTrips];

                                  if (value === "Other") {
                                    updated[index].fromMode = "manual";
                                    updated[index].from = {
                                      ...updated[index].from,
                                      name: "",
                                      lat: null,
                                      lng: null,
                                    };
                                  } else {
                                    const selected = destinationOptions.find(
                                      (d) => d.Destination === value,
                                    );

                                    updated[index].fromMode = "select";
                                    updated[index].from = {
                                      ...updated[index].from,
                                      name: value,
                                    };
                                  }

                                  setRequestTrips(updated);
                                }}
                                style={{
                                  width: "100%",
                                  padding: "10px 12px",
                                  borderRadius: "8px",
                                  border: "1px solid #d0d0d0",
                                  backgroundColor: "#fff",
                                  fontSize: "14px",
                                  outline: "none",
                                }}
                                onFocus={(e) => {
                                  e.target.style.border = "1px solid #000";
                                }}
                                onBlur={(e) => {
                                  e.target.style.border = "1px solid #d0d0d0";
                                }}
                              >
                                <option value="select">Select From...</option>

                                {destinationOptions
                                  .filter((d) => d.name !== "Other...")
                                  .map((d, i) => (
                                    <option key={i} value={d.name}>
                                      {d.name}
                                    </option>
                                  ))}

                                <option value="Other">Other...</option>
                              </select>
                            </div>

                            {trip.fromMode === "manual" && (
                              <input
                                type="text"
                                placeholder="Enter From Location"
                                value={trip.from.name}
                                onChange={(e) => {
                                  const updated = [...requestTrips];
                                  updated[index].from.name = e.target.value;
                                  setRequestTrips(updated);
                                }}
                                style={{
                                  width: "100%",
                                  padding: "10px 12px",
                                  borderRadius: "8px",
                                  border: "1px solid #d0d0d0",
                                  fontSize: "14px",
                                  outline: "none",
                                }}
                              />
                            )}
                          </div>

                          {/* TO */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "6px",
                              marginBottom: "10px",
                            }}
                          >
                            <label style={{ fontWeight: 600 }}>To:</label>

                            <div className="styled-select">
                              <select
                                value={
                                  trip.toMode === "manual"
                                    ? "Other"
                                    : trip.to.name || "select"
                                }
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const updated = [...requestTrips];

                                  if (value === "Other") {
                                    updated[index].toMode = "manual";
                                    updated[index].to = {
                                      ...updated[index].to,
                                      name: "",
                                      lat: null,
                                      lng: null,
                                    };
                                  } else {
                                    updated[index].toMode = "select";

                                    const selected = destinationOptions.find(
                                      (d) =>
                                        (d.Destination ?? d.name) === value,
                                    );

                                    updated[index].to = {
                                      name:
                                        selected?.Destination ??
                                        selected?.name ??
                                        value,
                                      lat:
                                        selected?.Lat ?? selected?.lat ?? null,
                                      lng:
                                        selected?.Lon ?? selected?.lng ?? null,
                                    };
                                  }

                                  setRequestTrips(updated);
                                }}
                                style={{
                                  width: "100%",
                                  padding: "10px 12px",
                                  borderRadius: "8px",
                                  border: "1px solid #d0d0d0",
                                  backgroundColor: "#fff",
                                  fontSize: "14px",
                                  outline: "none",
                                }}
                                onFocus={(e) => {
                                  e.target.style.border = "1px solid #000";
                                }}
                                onBlur={(e) => {
                                  e.target.style.border = "1px solid #d0d0d0";
                                }}
                              >
                                <option value="select">Select To...</option>

                                {destinationOptions
                                  .filter((d) => d.name !== "Other...")
                                  .map((d, i) => (
                                    <option key={i} value={d.name}>
                                      {d.name}
                                    </option>
                                  ))}

                                <option value="Other">Other...</option>
                              </select>
                            </div>

                            {trip.toMode === "manual" && (
                              <input
                                type="text"
                                placeholder="Enter To Location"
                                value={trip.to.name}
                                onChange={(e) => {
                                  const updated = [...requestTrips];
                                  updated[index].to.name = e.target.value;
                                  setRequestTrips(updated);
                                }}
                                style={{
                                  width: "100%",
                                  padding: "10px 12px",
                                  borderRadius: "8px",
                                  border: "1px solid #d0d0d0",
                                  fontSize: "14px",
                                  outline: "none",
                                }}
                              />
                            )}
                          </div>
                        </div>

                        <div
                          style={{
                            marginTop: "12px",
                            paddingTop: "8px",
                            borderTop: "1px solid #eee",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        ></div>

                        <label>Time:</label>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            marginBottom: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            overflow: "hidden",
                          }}
                        >
                          {/* departing at */}
                          <button
                            type="button"
                            onClick={() => {
                              const updated = [...requestTrips];
                              updated[index].mode = "departing";
                              setRequestTrips(updated);
                            }}
                            style={{
                              flex: 1,
                              padding: "8px",
                              border: "none",
                              cursor: "pointer",
                              background:
                                trip.mode === "departing" ? "#000" : "#fff",
                              color:
                                trip.mode === "departing" ? "#fff" : "#000",
                            }}
                          >
                            {departAtText}
                          </button>

                          {/* arrive by */}
                          <button
                            type="button"
                            onClick={() => {
                              const updated = [...requestTrips];
                              updated[index].mode = "arriveBy";
                              setRequestTrips(updated);
                            }}
                            style={{
                              flex: 1,
                              padding: "8px",
                              border: "none",
                              cursor: "pointer",
                              background:
                                trip.mode === "arriveBy" ? "#000" : "#fff",
                              color: trip.mode === "arriveBy" ? "#fff" : "#000",
                            }}
                          >
                            {arriveByText}
                          </button>
                        </div>
                        <input
                          type="time"
                          step="60"
                          value={currentTime}
                          style={{ marginBottom: "10px" }}
                          min={
                            selectedDate ===
                            `${new Date().getFullYear()}-${String(
                              new Date().getMonth() + 1,
                            ).padStart(
                              2,
                              "0",
                            )}-${String(new Date().getDate()).padStart(2, "0")}`
                              ? getDefaultDARTime(selectedDate)
                              : undefined
                          }
                          onChange={(e) => {
                            const value = e.target.value;

                            const minimumDateTime = new Date();
                            minimumDateTime.setHours(
                              minimumDateTime.getHours() +
                                Number(clientData?.DARMinHoursInAdvance || 0),
                            );

                            const selectedDateTime = new Date(
                              `${selectedDate}T${value}`,
                            );

                            const today = new Date();
                            const todayString =
                              `${today.getFullYear()}-` +
                              `${String(today.getMonth() + 1).padStart(2, "0")}-` +
                              `${String(today.getDate()).padStart(2, "0")}`;

                            if (
                              selectedDate === todayString &&
                              selectedDateTime < minimumDateTime
                            ) {
                              return;
                            }

                            if (!isTimeValid(index, value)) return;

                            const updated = [...requestTrips];
                            updated[index].datetime =
                              `${selectedDate}T${value}`;

                            setRequestTrips(updated);
                          }}
                        />
                        {selectedDate ===
                          `${new Date().getFullYear()}-${String(
                            new Date().getMonth() + 1,
                          ).padStart(
                            2,
                            "0",
                          )}-${String(new Date().getDate()).padStart(2, "0")}` && (
                          <div
                            style={{
                              fontSize: "11px",
                              color: "#999",
                              marginTop: "-6px",
                              marginBottom: "10px",
                            }}
                          >
                            You can only book{" "}
                            {clientData?.DARMinHoursInAdvance || 0}{" "}
                            {Number(clientData?.DARMinHoursInAdvance) === 1
                              ? "hour"
                              : "hours"}{" "}
                            in advance.
                          </div>
                        )}

                        <div
                          style={{
                            marginTop: "12px",
                            paddingTop: "8px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ fontWeight: "500" }}>Return:</span>

                          <div style={{ display: "flex", gap: "8px" }}>
                            <button
                              type="button"
                              onClick={() => {
                                const updated = [...requestTrips];
                                updated[index].isReturn = true;
                                setRequestTrips(updated);
                              }}
                              style={{
                                padding: "6px 12px",
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                                background: trip.isReturn ? "#000" : "#fff",
                                color: trip.isReturn ? "#fff" : "#000",
                                cursor: "pointer",
                              }}
                            >
                              Yes
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                const updated = [...requestTrips];
                                updated[index].isReturn = false;
                                updated[index].returnTime = "";
                                setRequestTrips(updated);
                              }}
                              style={{
                                padding: "6px 12px",
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                                background: trip.isReturn ? "#fff" : "#000",
                                color: trip.isReturn ? "#000" : "#fff",
                                cursor: "pointer",
                              }}
                            >
                              No
                            </button>
                          </div>
                        </div>

                        {trip.isReturn && (
                          <>
                            <input
                              type="time"
                              step="300"
                              value={trip.returnTime || ""}
                              style={{
                                marginTop: "8px",
                                width: "100%",
                              }}
                              onChange={(e) => {
                                const updated = [...requestTrips];
                                updated[index].returnTime = e.target.value;
                                setRequestTrips(updated);
                              }}
                            />

                            {getTripError(trip, index) && (
                              <div
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "4px",
                                }}
                              >
                                {getTripError(trip, index)}
                              </div>
                            )}
                          </>
                        )}

                        <div
                          style={{
                            marginTop: "12px",
                            paddingTop: "8px",
                            borderTop: "1px solid #eee",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        ></div>

                        <div style={{ marginBottom: "10px" }}>
                          <label>Aid:</label>
                          <select
                            value={trip.aid ?? ""}
                            onChange={(e) => {
                              const updated = [...requestTrips];
                              updated[index] = {
                                ...updated[index],
                                aid: e.target.value,
                              };
                              setRequestTrips(updated);
                            }}
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              marginBottom: "8px",
                              borderRadius: "8px",
                              border: "1px solid #d0d0d0",
                              backgroundColor: "#fff",
                              fontSize: "14px",
                              outline: "none",
                            }}
                            onFocus={(e) => {
                              e.target.style.border = "1px solid #000";
                            }}
                            onBlur={(e) => {
                              e.target.style.border = "1px solid #d0d0d0";
                            }}
                          >
                            {aids.length > 1 && (
                              <option value="" disabled>
                                Select an aid...
                              </option>
                            )}

                            <option value="None">None</option>

                            {aids.map((aid) => (
                              <option key={aid.code} value={aid.code}>
                                {aid.description}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div
                          style={{
                            marginTop: "12px",
                            paddingTop: "8px",
                            borderTop: "1px solid #eee",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        ></div>

                        <div style={{ marginBottom: "10px" }}>
                          <label>Passengers:</label>
                          {paxTypes.map((pax, i) => (
                            <div key={pax.key} style={{ marginBottom: "10px" }}>
                              <label>{pax.label}</label>

                              <input
                                type="number"
                                min="0"
                                max={pax.max}
                                value={pax.value}
                                onChange={(e) => {
                                  const updated = [...paxTypes];
                                  updated[i].value = Math.min(
                                    pax.max,
                                    Math.max(0, Number(e.target.value)),
                                  );
                                  setPaxTypes(updated);
                                }}
                              />
                            </div>
                          ))}
                        </div>

                        <div
                          style={{
                            marginTop: "12px",
                            paddingTop: "8px",
                            borderTop: "1px solid #eee",
                            position: "relative",
                          }}
                        >
                          <label>Notes:</label>

                          <textarea
                            value={notes}
                            maxLength={1000}
                            onChange={(e) => setNotes(e.target.value)}
                            placeholder="Add any additional instructions..."
                            style={{
                              width: "100%",
                              minHeight: "100px",
                              resize: "vertical",
                              padding: "10px",
                              borderRadius: "6px",
                              border: "1px solid #ccc",
                              boxSizing: "border-box",
                              fontSize: "14px",
                            }}
                          />

                          <div
                            style={{
                              position: "absolute",
                              bottom: "6px",
                              right: "10px",
                              fontSize: "12px",
                              color: "#666",
                              background: "white",
                              padding: "0 4px",
                            }}
                          >
                            {1000 - notes.length} remaining
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  <div
                    style={{
                      marginTop: "12px",
                      paddingTop: "8px",
                      borderTop: "1px solid #eee",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  ></div>

                  <button
                    className="button full-width"
                    style={{
                      marginTop: "10px",
                      opacity: canBook ? 1 : 0.4,
                      cursor: canBook ? "pointer" : "not-allowed",
                    }}
                    disabled={!canBook}
                    onClick={() => {
                      if (!canBook) return;

                      const payload = requestTrips.flatMap((trip) => {
                        const totalPassengers = paxTypes.reduce(
                          (sum, p) => sum + (Number(p.value) || 0),
                          0,
                        );

                        const aidObj = aids.find((a) => a.code === trip.aid);

                        const baseTrip = {
                          datetime: trip.datetime,
                          from: trip.from.name,
                          to: trip.to.name,
                          latFrom: trip.from.lat,
                          lngFrom: trip.from.lng,
                          latTo: trip.to.lat,
                          lngTo: trip.to.lng,

                          mode: trip.mode,

                          aidCode: aidObj?.code || null,
                          aid: aidObj?.description || "None",
                          passengers: totalPassengers,

                          notes: notes || "No Notes...",
                        };

                        if (trip.isReturn && trip.returnTime) {
                          const aidObj = aids.find((a) => a.code === trip.aid);
                          const returnTrip = {
                            datetime: `${selectedDate}T${trip.returnTime}`,
                            from: trip.to.name,
                            to: trip.from.name,
                            latFrom: trip.to.lat,
                            lngFrom: trip.to.lng,
                            latTo: trip.from.lat,
                            lngTo: trip.from.lng,

                            mode: "return",

                            aidCode: aidObj?.code || null,
                            aid: aidObj?.description || "None",
                            passengers: totalPassengers,

                            notes: notes || "No Notes...",
                          };

                          return [baseTrip, returnTrip];
                        }

                        return [baseTrip];
                      });

                      setConfirmPayload(payload);

                      const requestedDateTime = requestTrips[0]?.datetime;
                      const existingTrips =
                        getExistingTripsForDate(requestedDateTime);

                      if (existingTrips.length > 0) {
                        setBookingStep(2.5);
                      } else {
                        setBookingStep(3);
                      }
                    }}
                  >
                    Submit
                  </button>
                </>
              )}
              {bookingStep === 2.5 && (
                <>
                  <div
                    style={{
                      padding: "14px",
                      marginBottom: "15px",
                      border: "1px solid #e0a800",
                      borderRadius: "8px",
                      backgroundColor: "#fff8dd",
                    }}
                  >
                    <h3 style={{ marginTop: 0 }}>Trips already booked</h3>

                    <p>
                      You already have one or more trips booked on{" "}
                      <strong>
                        {formatDisplayDate(requestTrips[0]?.datetime)}
                      </strong>
                      .
                    </p>

                    <p>
                      Please check the existing trips before continuing with
                      this new {bookingName.toLowerCase()} request.
                    </p>
                  </div>

                  <div className="array-list">
                    {getExistingTripsForDate(requestTrips[0]?.datetime).map(
                      (existingTrip) => (
                        <div
                          key={`existing-booking-${existingTrip.id}`}
                          className="booking-trip-card"
                        >
                          <div className="booking-trip-header">
                            <strong>
                              {existingTrip.formatteddate} at{" "}
                              {existingTrip.time}
                            </strong>
                          </div>

                          <div
                            className="booking-trip-icon"
                            style={{ backgroundColor: "#2e7d32" }}
                          >
                            <span
                              style={{
                                color: "white",
                                fontSize: "0.75rem",
                                fontWeight: "600",
                              }}
                            >
                              Booked
                            </span>
                          </div>

                          <div className="booking-trip-body">
                            <p>
                              <strong>From:</strong>{" "}
                              {existingTrip.from?.name || "Not available"}
                            </p>

                            <p>
                              <strong>To:</strong>{" "}
                              {existingTrip.to?.name || "Not available"}
                            </p>

                            <p>
                              <strong>Time:</strong>{" "}
                              {existingTrip.time || "Not available"}
                            </p>

                            <p>
                              <strong>Aid:</strong> {existingTrip.aid || "None"}
                            </p>

                            <p>
                              <strong>Passengers:</strong>{" "}
                              {existingTrip.passengers}
                            </p>

                            {existingTrip.status && (
                              <p>
                                <strong>Status:</strong> {existingTrip.status}
                              </p>
                            )}
                          </div>
                        </div>
                      ),
                    )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginTop: "15px",
                    }}
                  >
                    <button
                      className="button"
                      style={{ flex: 1 }}
                      onClick={() => setBookingStep(2)}
                    >
                      Back
                    </button>

                    <button
                      className="button"
                      style={{ flex: 1 }}
                      onClick={() => setBookingStep(3)}
                    >
                      OK, Continue
                    </button>
                  </div>
                </>
              )}
              {bookingStep === 3 && (
                <>
                  <div className="array-list">
                    {confirmPayload.map((trip, index) => {
                      const totalPassengers = paxTypes.reduce(
                        (sum, p) => sum + (Number(p.value) || 0),
                        0,
                      );

                      return (
                        <div key={index} className="booking-trip-card">
                          <div className="booking-trip-header">
                            <strong>
                              {formatDateTimeDisplay(trip.datetime)}
                            </strong>
                          </div>

                          <div
                            className="booking-trip-icon"
                            style={{ backgroundColor: "#FFBF00" }}
                          >
                            <i
                              className="fa-solid fa-bus"
                              style={{ color: "white" }}
                            />
                          </div>

                          <div className="booking-trip-body">
                            <p>
                              <strong>From:</strong> {trip.from}
                            </p>
                            <p>
                              <strong>To:</strong> {trip.to}
                            </p>

                            <p>
                              <strong>Aid:</strong> {trip.aid || "None"}
                            </p>

                            <p>
                              <strong>Passengers:</strong> {totalPassengers}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div
                    style={{
                      marginTop: "15px",
                      paddingTop: "10px",
                      borderTop: "1px solid #ddd",
                    }}
                  >
                    <strong>Notes</strong>

                    <div
                      style={{
                        whiteSpace: "pre-wrap",
                        color: "#444",
                        marginTop: "6px",
                      }}
                    >
                      {confirmPayload[0]?.notes || "None"}
                    </div>
                  </div>

                  <div
                    style={{ marginTop: "10px", display: "flex", gap: "10px" }}
                  >
                    <button
                      className="button"
                      style={{ flex: 1 }}
                      onClick={() => setBookingStep(2)}
                    >
                      Back
                    </button>

                    <button
                      className="button"
                      style={{ flex: 1 }}
                      disabled={confirmButtonLoading}
                      onClick={async () => {
                        setConfirmButtonLoading(true);

                        try {
                          const firstTrip = confirmPayload[0];

                          const paxType1 =
                            paxTypes.find((p) => p.key === "PaxType1")?.value ||
                            0;

                          const paxType2 =
                            paxTypes.find((p) => p.key === "PaxType2")?.value ||
                            0;

                          const paxType3 =
                            paxTypes.find((p) => p.key === "PaxType3")?.value ||
                            0;

                          let tripTime = firstTrip.datetime.split("T")[1];
                          let arriveBy = 0;

                          if (firstTrip.mode === "arriveBy") {
                            tripTime = firstTrip.datetime.split("T")[1];
                            arriveBy = 1;
                          }

                          const payload = [
                            {
                              paxId: parsedPax[0]?.PaxId || "",
                              tripDate: firstTrip.datetime.split("T")[0],
                              tripTime,

                              puAddress: firstTrip.from,
                              doAddress: firstTrip.to,

                              puLat: firstTrip.latFrom,
                              puLng: firstTrip.lngFrom,
                              doLat: firstTrip.latTo,
                              doLng: firstTrip.lngTo,

                              paxType1,
                              paxType2,
                              paxType3,

                              aid: firstTrip.aidCode || "None",

                              isReturn: requestTrips[0]?.isReturn
                                ? "Yes"
                                : "No",
                              returnTime: requestTrips[0]?.returnTime || "",

                              notes: firstTrip.notes || "No Notes...",
                              arriveBy: arriveBy,
                            },
                          ];

                          await webServiceCall("CreateBooking", {
                            GUId: guid,
                            tripsJson: JSON.stringify(payload),
                          });

                          setBookingResult("success");
                          setBookingStep(4);
                        } catch (err) {
                          console.error("Booking failed:", err);
                          setBookingResult("error");
                          setBookingStep(4);
                        } finally {
                          setConfirmButtonLoading(false);
                        }
                      }}
                    >
                      {confirmButtonLoading
                        ? "Requesting..."
                        : "Confirm Request"}
                    </button>
                  </div>
                </>
              )}
              {bookingStep === 4 && (
                <div style={{ textAlign: "center", padding: "30px" }}>
                  {bookingResult === "success" ? (
                    <>
                      <h2 style={{ color: "green" }}>Complete</h2>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: confirmationText || "",
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <h2 style={{ color: "red" }}>Error</h2>
                      <p>Something went wrong. Please try again.</p>
                    </>
                  )}

                  <button
                    className="button"
                    style={{ marginTop: "20px" }}
                    onClick={() => {
                      resetBookingFlow();
                    }}
                  >
                    Continue...
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {bookingDetailsTrips.length > 0 && (
        <BookingDetailsPopup
          bookingDetailsTrips={bookingDetailsTrips}
          onClose={() => setBookingDetailsTrips([])}
        />
      )}
    </aside>
  );
}
